class DrawerSizeGuide extends HTMLElement {
  data: any;
  $name: HTMLElement;
  $table: HTMLElement;
  $image: HTMLElement;
  $notes: HTMLElement;

  constructor() {
    super();
    // Read data from inline <script type="application/json" class="size-guide-data"> rendered by Liquid.
    // This avoids loading all size guides into window.metaobjectSizeGuides on every page.
    const $dataScript = this.querySelector<HTMLScriptElement>("script.size-guide-data");
    if ($dataScript) {
      try {
        this.data = JSON.parse($dataScript.textContent || "null");
      } catch (e) {
        console.warn("Failed to parse size guide data:", e);
        this.data = null;
      }
    } else {
      // Fallback for legacy behaviour (window.metaobjectSizeGuides) — kept for safety in case
      // some page still uses the old approach. Can be removed once we're sure nothing depends on it.
      this.data = (window as any).metaobjectSizeGuides?.find((d: any) => d.id === this.dataset.sizeGuideId);
    }
    this.$name = this.querySelector(".size-guide-name")!;
    this.$table = this.querySelector(".size-guide-table")!;
    this.$image = this.querySelector(".size-guide-how-to-measure-image")!;
    this.$notes = this.querySelector(".size-guide-notes")!;
  }

  connectedCallback() {
    if (!this.data) return;
    this.setupName();
    this.setupTable();
    this.setupImage();
    this.setupNotes();
  }

  setupName() {
    if (!this.data) return;
    const { name } = this.data;
    this.$name.textContent = name;
  }

  setupTable() {
    if (!this.data) return;
    const { table_rows } = this.data;
    const $tbody = this.$table.querySelector<HTMLTableSectionElement>("tbody")!;

    // table_rows may be:
    //   - an array of strings (legacy format: ["Size,XS,S,M", "Chest,80,85,90"]) — needs splitting by ","
    //   - an array of arrays (already parsed) — use as-is
    table_rows.forEach((row: any) => {
      const cells = Array.isArray(row) ? row : (typeof row === "string" ? row.split(",") : []);
      const $tr = document.createElement("tr");
      cells.forEach((cell: any) => {
        const $td = document.createElement("td");
        $td.textContent = cell?.toString().trim() ?? "";
        $tr.appendChild($td);
      });
      $tbody.appendChild($tr);
    });
  }

  setupImage() {
    if (!this.data) return;
    const { how_to_measure_image } = this.data;
    if (!how_to_measure_image) return;
    const $img = document.createElement("img");
    $img.src = how_to_measure_image;
    $img.style.maxWidth = "100%";
    this.$image.appendChild($img);
  }

  setupNotes() {
    if (!this.data) return;
    const { notes } = this.data;
    if (notes) this.$notes.textContent = notes;
  }
}

customElements.define("drawer-size-guide", DrawerSizeGuide);
